import KnockOut from "knockout";
import BasePage from "@Scripts/Pages/BasePage";
import ProductDetailViewModel from "@Scripts/ViewModels/ProductDetailViewModel";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class ProductDetailPage extends BasePage {
    public static async init() {
        await super.init();
        super.setCarouselProducts();

        (<any>window).App.viewModels.page = new ProductDetailViewModel();
        KnockOut.applyBindings((<any>window).App.viewModels.page, document.getElementById("Page"));

        this.setInsights();
        this.setProductDetailAnalytics();
    }

    public static setInsights() {
        var $insights = $(".insights"),
            settings = {
                lazyLoad: "ondemand",
                speed: 500,
                slidesToShow: 1,
                infinite: false,
                arrows: false,
                draggable: false,
                fade: true,
                adaptiveHeight: true,
                variableWidth: false,
                dots: true,
                appendDots: $('.insights .tabs'),
                customPaging: function (slider, i) {
                    return $(slider.$slides[i]).data('title');
                }
            };

        $(".views .item iframe[src*=\"youtube.com\"]", $insights).each(function () {
            $($(this)[0]).attr("src", $($(this)[0]).attr("src") + "&enablejsapi=1");
        });

        (<any>$(".views.slick-initialized")).slick("removeSlide", null, false, true);
        (<any>$(".views.slick-initialized")).slick("unslick");
        (<any>$(".views", $insights)).not(".slick-initialized").on('afterChange', function (e, o) {
            $("iframe[src*=\"youtube.com\"]").each(function () {
                (<any>$(this)[0]).contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
            });
        }).slick(settings);
    }

    private static setProductDetailAnalytics() {
        GTagHelper.sendEvent("view_item", {
            currency: "EUR",
            value: parseFloat((<any>window).App.bag.product.price.replace(/\./g, "").replace(",", ".")),
            items: [
                {
                    item_id: (<any>window).App.bag.product.code,
                    item_name: (<any>window).App.bag.product.title,
                    affiliation: "IloveOstrica",
                    item_category: (<any>window).App.bag.product.categoryName,
                    price: parseFloat((<any>window).App.bag.product.price.replace(/\./g, "").replace(",", "."))
                }
            ]
        });

        (<any>window).window.dataLayer = (<any>window).window.dataLayer || [];
        (<any>window).dataLayer.push({ ecommerce: null });
        (<any>window).dataLayer.push({
            event: "view_item",
            ecommerce: {
                currency: "EUR",
                value: parseFloat((<any>window).App.bag.product.price.replace(/\./g, "").replace(",", ".")),
                items: [
                    {
                        item_id: (<any>window).App.bag.product.code,
                        item_name: (<any>window).App.bag.product.title,
                        affiliation: "IloveOstrica",
                        item_category: (<any>window).App.bag.product.categoryName,
                        currency: "EUR",
                        price: parseFloat((<any>window).App.bag.product.price.replace(/\./g, "").replace(",", ".")),
                        quantity: 1
                    }
                ]
            }
        });
    }
}